import { render, staticRenderFns } from "./TransferRegionView.vue?vue&type=template&id=d76d6a8c&"
import script from "./TransferRegionView.vue?vue&type=script&lang=js&"
export * from "./TransferRegionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports